// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';
import About from '../views/About.vue';
import ContactForm from '@/components/ContactForm.vue';
import Callback from '../components/Callback.vue';
// import ListingForm from '@/components/ListingForm.vue';
import ListingWiz from '@/views/ListingWiz.vue';
import LotMapping from '@/views/LotMapping.vue';
import CurrentListings from '@/components/CurrentListings.vue';
import VenueMetrics from '@/components/VenueMetrics.vue';
import ProcessingConfig from '@/components/ ProcessingConfig.vue';
import SalesDashboard from '@/components/SalesDashboard.vue';
import VenueManagement from '@/components/VenueManagement.vue';
import PurchaseQueue from '@/components/PurchaseQueue.vue';
import EventMapping from '@/components/EventMapping.vue';
import SalesManagement from '@/views/SalesManagement.vue';
import RescheduledEventSales from '@/views/RescheduledEventSales.vue';


Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: SalesDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { requiresAuth: true }
  },
  {
    path: '/parkwhiz',
    name: 'ParkWhiz',
    component: ContactForm,
    meta: { requiresAuth: true }
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  },
  {
    path: '/listing',
    name: 'Listing Wizard',
    component: ListingWiz,
    meta: { requiresAuth: true }
  },
  {
    path: '/current-listings',
    name: 'Active Listings',
    component: CurrentListings,
    meta: { requiresAuth: true }
  },
  {
    path: '/lotmap',
    name: 'Lot Mapping',
    component: LotMapping,
    meta: { requiresAuth: true }
  },
  {
    path: '/metrics',
    name: 'Venue Metrics',
    component: VenueMetrics,
    meta: { requiresAuth: true }
  },
  {
    path: '/config',
    name: 'Processing Config',
    component: ProcessingConfig,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales',
    name: 'SalesDashboard',
    component: SalesDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/venues',
    name: 'Venue Management',
    component: VenueManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/purchase-queue',
    name: 'Purchase Queue',
    component: PurchaseQueue,
    meta: { requiresAuth: true }
  },
  {
    path: '/event-mapping',
    name: 'Event Mapping',
    component: EventMapping,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-management',
    name: 'Sales Management',
    component: SalesManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/rescheduled-sales',
    name: 'Rescheduled Event Sales',
    component: RescheduledEventSales,
    meta: { requiresAuth: true }
  }

];

export default new Router({
  mode: 'history',
  routes,
});
